// General Imports
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injectable } from '@angular/core';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpService } from './http.service';
import { DefaultUrlSerializer, Router, Scroll, UrlSerializer, UrlTree } from '@angular/router';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HeaderComponent } from './website/website-header/header.component';
import { FooterComponent } from './website/website-footer/footer.component';
import { LandingComponent } from './website/website-landing/landing.component';

// Other Components
// import { SolutionsComponent } from './pages-solutions/solutions/solutions.component';

// Nested
import { NestedCustomerCarouselComponent } from './nested-components/nested-customer-carousel/nested-customer-carousel.component';
import { NestedSidebarTm400GWallchartComponent } from './nested-sidebar/nested-sidebar-tm400-g-poster/nested-sidebar-tm400-g-wallchart.component';

import { NestedSidebarGigabitWhitepaperComponent } from './nested-sidebar/nested-sidebar-gigabit-whitepaper/nested-sidebar-gigabit-whitepaper.component';

import { NestedSidebarDocsis4WallchartComponent } from './nested-sidebar/nested-sidebar-docsis4-poster/nested-sidebar-docsis4-wallchart.component';
import { NestedMarketNavComponent } from './nested-nav/nested-nav-market/nested-market-nav.component';
import { NestedSidebarPassthroughtestingTechnoteComponent } from './nested-sidebar/nested-sidebar-passthroughtesting-technote/nested-sidebar-passthroughtesting-technote.component';
import { NestedSidebarOpticaltransceivertestingAppnoteComponent } from './nested-sidebar/nested-sidebar-opticaltransceivertesting-appnote/nested-sidebar-opticaltransceivertesting-appnote.component';
import { NestedUnderConstructionComponent } from './nested-components/nested-under-construction/nested-under-construction.component';
import { NestedHeaderNoticeComponent } from './nested-components/nested-header-notice/nested-header-notice.component';
import { NestedSidebarRdofFlyerComponent } from './nested-sidebar/nested-sidebar-rdof-flyer/nested-sidebar-rdof-flyer.component';
import { NestedPasswordProtectedFormComponent } from './nested-components/nested-password-protected-form/nested-password-protected-form.component';
import { NestedSidebarEthernet100g40gComponent } from './nested-sidebar/nested-sidebar-ethernet100g40g/nested-sidebar-ethernet100g40g.component';
import { NestedSidebarDocsis31PosterComponent } from './nested-sidebar/nested-sidebar-docsis31-poster/nested-sidebar-docsis31-poster.component';
import { NestedSidebarCablebasicsPosterComponent } from './nested-sidebar/nested-sidebar-cablebasics-poster/nested-sidebar-cablebasics-poster.component';
import { ViewportScroller } from '@angular/common';
import { filter } from 'rxjs/operators';
// import { ToolsMtx150lQuickguideComponent } from './tools/tools-mtx150l-quickguide/tools-mtx150l-quickguide.component';
import { NestedNavLandingComponent } from './nested-nav/nested-nav-landing/nested-nav-landing.component';
import { CompanyFormLeadsComponent } from './pages-company/company-form-leads/company-form-leads.component';
// import { ProductCategoryPonXgsPonComponent } from './product-category/product-category-pon-xgs-pon/product-category-pon-xgs-pon.component';
import { WebsiteCompanytestComponent } from './website/website-companytest/website-companytest.component';
import { NestedFloatingFormComponent } from './nested-components/nested-floating-form/nested-floating-form.component';
import { NestedSidebarFiberCatalogComponent } from './nested-sidebar/nested-sidebar-fiber-catalog/nested-sidebar-fiber-catalog.component';
import { NestedSidebarOpmApplicationGuideComponent } from './nested-sidebar/nested-sidebar-opm-application-guide/nested-sidebar-opm-application-guide.component';
import { NestedSidebarFttxponnetworksGuideComponent } from './nested-sidebar/nested-sidebar-fttxponnetworks-guide/nested-sidebar-fttxponnetworks-guide.component';
import { NestedSidebarFttxponnetworkstestsolutionsguideComponent } from './nested-sidebar/nested-sidebar-fttxponnetworkstestsolutionsguide/nested-sidebar-fttxponnetworkstestsolutionsguide.component';
// import { ScullyLibModule } from '@scullyio/ng-lib';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NestedSidebarOtdrPosterComponent } from './nested-sidebar/nested-sidebar-otdr-poster/nested-sidebar-otdr-poster.component';
import { NestedSidebarTestingPonPosterComponent } from './nested-sidebar/nested-sidebar-testing-pon-poster/nested-sidebar-testing-pon-poster.component';
import { WebsiteLandingV2Component } from './website/website-landing-v2/website-landing-v2.component';
import { NestedNavLandingV2Component } from './nested-nav/nested-nav-landing-v2/nested-nav-landing-v2.component';
import { NestedSidebarOtnPosterComponent } from './nested-sidebar/nested-sidebar-otn-poster/nested-sidebar-otn-poster.component';
// import { NestedSidebarEthernetFlyerComponent } from './nested-sidebar/nested-sidebar-ethernet-flyer/nested-sidebar-ethernet-flyer.component';
// import { StateoptionsComponent } from './components/stateoptions/stateoptions.component';
// import { ServiceWorkerModule } from '@angular/service-worker';
// import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Injectable()
export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
      // Optional Step: Do some stuff with the url if needed.
      // console.log(url);
      const rgx = new RegExp('^/company/unsubscribe.*$');
      // console.log(rgx.test(url));
      if (rgx.test(url)) {
        return super.parse(url);
      } else {
        return super.parse(url.toLowerCase());
      }
      // If you lower it in the optional step
      // you don't need to use "toLowerCase"
      // when you pass it down to the next function
  }
	// serialize(tree: UrlTree): any {
	// 	let path = super.serialize(tree);
	// 	let pathArr = path.split('?');
  //   if(pathArr[0].endsWith('/')) {
  //     pathArr[0] = pathArr[0].slice(0, -1);
  //   }
	// 	// pathArr[0] += '/';
	// 	return pathArr.join('?');
	// }
}


// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http,
    './assets/i18n/',
    '.json');
}

@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        LandingComponent,
        // AZProductListComponent,
        // ProductFamilyVesionComponent,
        // AppsComponent,
        // ServerRServerComponent,
        // SolutionsComponent,
        // SearchComponent,
        // VeexpressComponent,
        // NotFoundComponent,
        NestedSidebarTm400GWallchartComponent,
        // CompanyFormComponent,
        // DownloadComponent,
        NestedSidebarGigabitWhitepaperComponent,
        NestedCustomerCarouselComponent,
        // ScteCableTecComponent,
        // ScteCableTecFormComponent,
        NestedSidebarDocsis4WallchartComponent,
        // ScteCableTecScheduleComponent,
        // CusportalComponent,
        NestedMarketNavComponent,
        // ProductMarketTelecomtelcoComponent,
        // ProductMarketCatvmsoComponent,
        // ProductMarketCellularmobileComponent,
        // ProductMarketNetworkequipmentComponent,
        // ProductMarketInstallerscontractorsComponent,
        // ProductMarketDatacentersComponent,
        // ProductMarketGovernmentdefenseComponent,
        // ProductMarketUtilitiesmunicipalitiesComponent,
        // ProductMarketItenterpriseComponent,
        NestedSidebarPassthroughtestingTechnoteComponent,
        NestedSidebarOpticaltransceivertestingAppnoteComponent,
        // ToolsScreenprotectorComponent,
        NestedUnderConstructionComponent,
        NestedHeaderNoticeComponent,
        // ToolsChangelangComponent,
        // WebsiteComingsoonComponent,
        NestedSidebarRdofFlyerComponent,
        // ToolsBootUpPinHelpComponent,
        NestedPasswordProtectedFormComponent,
        NestedSidebarEthernet100g40gComponent,
        NestedSidebarDocsis31PosterComponent,
        NestedSidebarCablebasicsPosterComponent,
        // ToolsSitemapComponent,
        // ToolsMtx150lQuickguideComponent,
        // VxhelperComponent,
        // NestedSidebarCcinformationComponent,
        // VxhelperTx300s1gElectricalloopbacktestQuickguideComponent,
        // VxhelperTx300s1gOpticalloopbacktestQuickguideComponent,
        // VxhelperTx300s10gOpticall2loopbackthroughputtestQuickguideComponent,
        // VxhelperTx300s10gOpticall2throughputtestQuickguideComponent,
        // ToolsResourcesComponent,
        NestedNavLandingComponent,
        // WebsiteLandingtestComponent,
        CompanyFormLeadsComponent,
        // ProductCategoryPonXgsPonComponent,
        WebsiteCompanytestComponent,
        NestedFloatingFormComponent,
        NestedSidebarFiberCatalogComponent,
        NestedSidebarOpmApplicationGuideComponent,
        // NoappComponent,
        NestedSidebarFttxponnetworksGuideComponent,
        NestedSidebarFttxponnetworkstestsolutionsguideComponent,
        // NestedSidebarEthernetFlyerComponent,
        NestedSidebarOtdrPosterComponent,
        NestedSidebarTestingPonPosterComponent,
        WebsiteLandingV2Component,
        NestedNavLandingV2Component,
        NestedSidebarOtnPosterComponent
    ],
    exports: [],
    bootstrap: [AppComponent],
    imports: [AppRoutingModule,
        BrowserModule,
        TranslateModule.forRoot({
            defaultLanguage: 'en',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        BrowserAnimationsModule,
        // QRCodeModule,
        // ScullyLibModule.forRoot({
        //   alwaysMonitor: true,
        // }),
        SharedModule], providers: [
        HttpService,
        {
            provide: UrlSerializer,
            useClass: LowerCaseUrlSerializer
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {
  constructor(router: Router, viewportScroller: ViewportScroller,
    // private gtmService: GoogleTagManagerService,
    ) {
    // this.gtmService.addGtmToDom();
    viewportScroller.setOffset([0, 105]);
    router.events.pipe(filter(e => e instanceof Scroll)).subscribe((e: Scroll) => {
      if (e.anchor) {
          // anchor navigation
          /* setTimeout is the core line to solve the solution */
          setTimeout(() => {
              viewportScroller.scrollToAnchor(e.anchor);
          });
      } else if (e.position) {
          // backward navigation
          viewportScroller.scrollToPosition(e.position);
      } else {
          // forward navigation
          viewportScroller.scrollToPosition([0, 0]);
      }
    });
  }
}
